import styled from 'styled-components';

const NewsletterWrapper = styled.div`
  position: relative;
 
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 60px 80px;

  @media (max-width: 1220px) {
    padding: 35px 40px;
  }
  @media (max-width: 575px) {
    padding: 35px 20px;
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 990px) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
  .headTitle {
    @media (max-width: 768px) and (min-width:590px) {
      margin-left: 7%;
    }
  }
  .title {
    @media (max-width: 768px) and (min-width:590px) {
      margin-left: 19%;
    }
    @media (max-width:590px) {
      margin-left: 0%;
    }
  }
`;

export const ContactFormWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  width: 470px;
  max-width: 100%;

  @media (max-width: 1220px) {
    width: 420px;
    margin-left:0%
  }
  @media (max-width: 990px) {
    width: 420px;
    margin-left:22%
  }
  @media (max-width: 768px) and (min-width:590px) {
    justify-content: center;
    margin-bottom: 25px;
    margin-left:24%
    width:300px
    
    button {
      width: 100%;
    }
  }
  @media (max-width: 590px) {
    width: 100%;
    margin-left:0%

  }
 
  .email_input {
    flex-grow: 1;
    @media (max-width: 575px) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
      margin-left:10%
    }
    &.is-material {
      &.is-focus {
        label {
          font-size: 14px;
          color: #98e044;
        }
        .highlight {
          background: #98e044;
          height: 1px;
        }
      }
    }

    .highlight {
      background: #98e044;
    }

    input {
      background: transparent;
      font-size: 16px;
      font-weight: 400;
      color: #000;
      padding: 10px 15px;
      border-color: #98e044;
      @media (max-width: 575px) {
        height: 48px;
      }
    }

    label {
      font-size: 17px;
      color: #fff;
      font-weight: 400;
      padding-left: 10px;
      top: 5px;
      pointer-events: none;
    }
  }
  .reusecore__button {
    background-color: transparent;
    font-size: 16px;
    letter-spacing: -0.1px;
    border-radius: 5px;
    padding-left: 16px;
    padding-right: 16px;
    // text-transform: capitalize;
    &:hover {
      box-shadow: #1e2a4a 0px 12px 24px -10px;
    }
  }
  .reusecore__checkbox{
    align-items: center;
    justify-content: center;
    display: flex;
  }
`;

export default NewsletterWrapper;
